import React from 'react'
import { Field } from 'redux-form/immutable'

import { IContactStepProps } from './interface'
// @ts-ignore
import { minLength, required, email } from 'helpers/validators'
import { trimmed, trimmedAndExclusionSpecialSymbolsForUserName } from 'helpers/reviews'
import Button from 'app/components/ButtonDefault/ButtonDefault'
import Input from 'app/components/Input'

const isRequired = required()
const minLength3 = minLength(3)

const ContactStep: React.FC<IContactStepProps> = ({
  firstNameLabel,
  firstNameField,
  lastNameLabel,
  lastNameField,
  emailLabel,
  emailField,
  nextStep,
  customAction,
  disabled,
  btnText = 'Continue',
  isActive,
  title,
  isRequiredStep = true,
  skipBtnText = 'Skip',
  currentStep = 0,
  goToStep,
  stepsForEndBlock = 0,
}) => {
  return (
    <div>
      <h2>{title}</h2>
      <Field
        label={`${firstNameLabel} *`}
        name={firstNameField || 'firstName'}
        component={Input}
        style={{ width: '100%' }}
        validate={[isRequired, minLength3]}
        autoFocus={isActive}
        normalize={trimmedAndExclusionSpecialSymbolsForUserName}
      />
      <Field
        label={`${lastNameLabel} *`}
        name={lastNameField || 'lastName'}
        component={Input}
        validate={[isRequired, minLength3]}
        normalize={trimmedAndExclusionSpecialSymbolsForUserName}
      />
      <Field
        label={`${
          typeof emailLabel === 'string' ? emailLabel : firstNameField ? emailLabel(firstNameField) : 'Email'
        } *`}
        name={emailField || 'email'}
        component={Input}
        validate={[isRequired, email]}
        normalize={trimmed}
      />
      <div>
        <Button
          type="button"
          primary
          onClick={() => {
            nextStep && nextStep()
            customAction && customAction()
          }}
          disabled={disabled}
          tabIndex={-1}
        >
          {btnText}
        </Button>
        {!isRequiredStep && (
          <Button
            type="button"
            primary
            onClick={() => {
              goToStep && goToStep(currentStep + stepsForEndBlock)
            }}
            tabIndex={-1}
          >
            {skipBtnText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default ContactStep
